import { FC } from 'react'
import { Form } from 'react-bootstrap'
import { FieldProps } from '../Forms.d'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAsterisk } from '@fortawesome/free-solid-svg-icons'

const TextField: FC<FieldProps> = ({
    id,
    label = '',
    showLabel = true,
    name,
    formikProps,
    placeholder = '',
    groupClassName = '',
    className = '',
    required = false,
    disabled = false,
    readonly = false,
    onBlur,
    type,
}) => {
    const { values, errors, touched, handleChange, submitCount } = formikProps
    const showError = errors[name] && (touched[name] || (submitCount != null && submitCount > 0))

    return (
        <Form.Group
            className={
                (groupClassName || '') +
                ' sfy-field mb-3' +
                (required ? ' required' : '')
            }
            controlId={id}
        >
            {showLabel && (
                <Form.Label>
                    {label}{' '}
                    {required && (
                        <FontAwesomeIcon
                            icon={faAsterisk}
                            className="text-danger"
                            size="xs"
                        />
                    )}
                </Form.Label>
            )}
            <Form.Control
                type={type || 'text'}
                name={name}
                value={values[name] || ''}
                onChange={handleChange}
                onBlur={(e) => {
                    if (onBlur) onBlur(e)
                }}
                placeholder={placeholder}
                className={
                    (className || '') +
                    ' ' +
                    (showError ? 'is-invalid' : '') +
                    (readonly ? ' readonly' : '')
                }
                disabled={disabled}
                readOnly={readonly}
                autoComplete={name + '-' + new Date().getMilliseconds()}
            />
            <span className="bottom-border"></span>
            {showError && (
                <Form.Text className="invalid-feedback">
                    {errors[name].toString()}
                </Form.Text>
            )}
        </Form.Group>
    )
}

export default TextField
